// extracted by mini-css-extract-plugin
module.exports = {"styles":"_1ErnkM6VouRysLzpNhujaH"};